/* eslint-disable react/forbid-prop-types */
/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */

import React, { useState, useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useDropzone } from 'react-dropzone';
import Clip from 'assets/icons/clip-icon.svg';
import ClipGreen from 'assets/icons/clip-icon-green.svg';
import { Wrapper } from './styles';

/**
 * # Input File (Upload) #
 */

const InputFile = ({
  onChange, status, changeStatus, originFiles,
}) => {
  const [files, setFiles] = useState([]);
  const [text, setText] = useState();

  useEffect(() => {
    setFiles(originFiles);
  }, [originFiles]);

  // Callback ao arrastar arquivos
  const onDrop = useCallback((acceptedFiles) => {
    onChange(acceptedFiles);
    setFiles(acceptedFiles);
    changeStatus(false);
  }, []);

  const {
    getRootProps,
    getInputProps,
  } = useDropzone({ onDrop });

  // Label do input
  const Label = () => {
    if (!files.length || status) {
      setText('Clique aqui para ENVIAR seus EXTRATOS');
    } else if (files.length === 1) {
      setText(`${files.length} Arquivo selecionado`);
    } else {
      setText(`${files.length} Arquivos selecionados`);
    }
    return (
      <p>
        {text}
      </p>
    );
  };

  return (
    <Wrapper id="select-files" status={!files.length || status}>
      <input {...getInputProps()} accept="application/pdf" />
      <div>
        <img src={!files.length || status ? ClipGreen : Clip} alt="icon" />
        <Label />
      </div>
    </Wrapper>
  );
};

InputFile.defaultProps = {
  originFiles: [],
};

InputFile.propTypes = {
  originFiles: PropTypes.array,
  onChange: PropTypes.func.isRequired,
};

export default InputFile;
